import { useCallback } from "react";

interface UseVideoControlsProps {
  videoRef: React.RefObject<HTMLMediaElement>;
}

export const useVideoControls = ({ videoRef }: UseVideoControlsProps) => {
  const seek = useCallback(
    (time: number) => {
      if (!videoRef.current) return;

      videoRef.current.currentTime = time;
    },
    [videoRef],
  );

  const pause = useCallback(() => {
    if (!videoRef.current) return;

    videoRef.current.pause();
  }, [videoRef]);

  return {
    seek,
    pause,
  };
};
